
  import { defineComponent } from 'vue';
  import { linkWhatsApp } from '@/uteis/contato';
  import { registrarClique } from '@/uteis/metricas';

  export default defineComponent({
    name: 'CaixaServico',
    props: {
        Numero: {
            type: String,
            default: ""
        },
        Titulo: {
            type: String,
            default: ""
        },
        Texto: {
            type: String,
            default: ""
        },
        Imagem: {
            type: String,
            default: ""
        },
        TextoWhatsApp: {
            type: String,
            default: ""
        }
    },
    methods: {
        linkWhatsApp,
        registrarClique
    }
  });
